import {
  CollectionEntryFragment,
  getTypeOrNull,
  isType,
} from '@spotify/confidence-graphql';

import { getMetricStateDisplay } from '../components/MetricStateIndicator/metricStateDisplay';

type EntryResource = NonNullable<CollectionEntryFragment['resource']>;

export const getMetricState = (resource: EntryResource): string => {
  if (!isType(resource, 'MetricsV1Metric') || !resource.state) return '-';
  return getMetricStateDisplay(resource.state).label;
};

export const getMetricFactTable = (resource: EntryResource): string => {
  if (!isType(resource, 'MetricsV1Metric')) return '-';
  return getTypeOrNull(resource.factTable)?.displayName ?? '-';
};
